import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {OrbitSwiperComponent} from '../orbit-swiper/orbit-swiper.component';
import {observer} from 'mobx-react';
import {ISwiperListViewModel} from "../../services/arenas/models/lists/swiper-list-view-model.interface";


interface TopPicksComponentProps {
  viewModel: ISwiperListViewModel;
  listPosition: number;
}

@observer
export class TopPicksComponent extends OrbitComponent<TopPicksComponentProps> {

  render() {

    const viewModel = this.props.viewModel;

    return (
        <OrbitSwiperComponent viewModel={viewModel} className={'ai-games-list cy-top-picks-list'} listPosition={this.props.listPosition}/>
    );
  }
}


